<!-- <button mat-icon-button class="close-button" [mat-dialog-close]="true" (click)="dialogRef.close(false)">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button> -->

<h1 mat-dialog-title class="text-center blueHeader dialogHeader text-white">Consume Drug</h1>
<mat-dialog-content class="mb-4 text-center">
  <div class="mt-3 wid" style="min-height: 220px;">
    <div class="mb-2">
      <label for="category" class="toPay col-md-4">Category</label>
      <select name="category" id="category" class="form-control input-font category inputBox col-md-8 d-inline-block"
        [(ngModel)]="category" (change)="categoryChanged()">
        <option value="TABLET">Tablet</option>
        <option value="SYRUP-SUPPLEMENT">Syrup</option>
        <option value="VACCINATION-DEWORMING">Vaccination / Deworming</option>
        <option value="DISPOSABLE">Disposables</option>
        <option value="DROPS">Drops</option>
        <option value="INJECTABLE">Injectables</option>
        <option value="POWDER-SHAMPOO">Powder / Shampoo</option>
        <option value="OINTMENT-SPRAY">Ointment / Spray</option>
        <option value="PRODUCT">Consumables</option>
        <option value="SERVICES">Others</option>
      </select>
    </div>
    <div class="mb-2">
      <label for="name" class="payingClinic col-md-4">Name</label>
      <ng-select [items]="nameData" bindLabel="name" [addTag]="false" [multiple]="false" placeholder="Select Item"
        (change)="onNameChange($event)" [clearable]="false" class="col-md-8 d-inline-block pl-0 pr-0"
        [(ngModel)]="name_selected">
      </ng-select>
    </div>
    <div class="mb-2">
      <label for="qty" class="toPay col-md-4 required">Quantity</label>
      <input type="text" numbersOnly class="form-control input-font qty inputBox col-md-8 d-inline-block" id="qty"
        [(ngModel)]="qty" min="0">
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="col-md-12 text-center">
    <button mat-button class="mat-raised-button btn mr-4 blankTurquoise btnWidth" (click)="dialogRef.close(false)"
      title="Click to cancel reduction of stock from the
      inventory">{{cancelButton}}</button>
    <button mat-button class="mat-raised-button btn turquoiseBtn btnWidth" (click)="onConfirm()"
      title="Click to confirm reduction of stock from the inventory">{{successButton}}</button>
  </div>
</mat-dialog-actions>
